import { formatMoney } from 'libs/shopify'
import { PRODUCT_TYPES } from 'helpers/constants'
import Image from 'snippets/image/image'
import Price from 'snippets/price/price'
import PlpQuickAdd from 'snippets/plp-quick-add/plp-quick-add'

function ProductCardCustom({ product, productBundles }) {
  const bundleBadgeLabel = GM_STATE?.customs?.bundleBadgeLabel
  const hasNoNotifyMeTag = product?.tags?.includes?.('no-notify-me') || false
  const hasRechargeBundleTag = product?.tags?.includes('recharge-bundle') || false
  const productUrl = product?.url || `/products/${product.handle}`

  return (
    <div className="relative flex h-full">
      <a
        href={productUrl}
        className="relative aspect-4/5 w-[155px] border-r border-neutral-900 bg-neutral-100 lg:w-[143px]"
      >
        <Image
          url={product.featuredImage?.src}
          alt={product.title}
          width={400}
          height={500}
          className="size-full"
          imageClass="absolute top-0 left-0 size-full object-cover"
        />
      </a>
      <div className="flex flex-1 flex-col lg:my-auto lg:flex-row lg:items-center lg:gap-4 lg:py-3 lg:pl-8 lg:pr-10">
        <div className="flex-1 border-neutral-900 lg-max:border-b lg-max:px-4 lg-max:pb-3 lg-max:pt-5">
          <a href={productUrl} className="mb-0.5 block text-xs font-extrabold uppercase text-neutral-900">
            {product.title}
          </a>
          {product.type && <p className="mb-0.5 text-xs capitalize text-neutral-700">{product.type}</p>}
          {product.metafields.custom_scent && (
            <div className="mb-2 text-xs text-neutral-700">{product.metafields.custom_scent}</div>
          )}
          <div className="flex items-center gap-2.5">
            <Price
              price={product.price}
              originalPrice={product.compare_at_price}
              classSalePrice={product.type === PRODUCT_TYPES.VALUE_BUNDLE ? 'hidden' : ''}
              className="text-xs text-neutral-900"
            />
            {product.compare_at_price > product.price && product.type === PRODUCT_TYPES.VALUE_BUNDLE && (
              <span className="flex items-center justify-center bg-neutral-100 px-1.5 pt-1 text-xxs uppercase text-black">{`${bundleBadgeLabel} ${formatMoney(product.compare_at_price)?.replace('.00', '') || 0}`}</span>
            )}
          </div>
        </div>
        <div className="w-full lg:w-fit lg:min-w-[139px]">
          {hasRechargeBundleTag ? (
            <a
              href={productUrl}
              className="button-outlined relative flex w-full items-center justify-center px-3 text-center lg:mt-4 lg:px-4 lg-max:border-none"
            >
              {translate.bundle.viewProductBundle}
            </a>
          ) : (
            <PlpQuickAdd
              product={product}
              productBundles={productBundles}
              currentVariant={product.variants[0]}
              hiddenPrice
              hasNoNotifyMeTag={hasNoNotifyMeTag}
              textButton={translate.general.addToCart}
              classButton="w-full lg-max:border-none text-center !justify-center"
            />
          )}
        </div>
      </div>
    </div>
  )
}

export default ProductCardCustom
